import Component from '../Component';
import React from 'react';
import {Select} from 'reactis-inputs';

export default class ActiveSelect extends Component {

	render() {

		const options = [{id: 1, title: 'Aktivní'}, {id: 2, title:'Archiv'}, {id: 3, title:'Vše'}];

		return (
			<Select {...this.props}
				style={{width: 100, display:'block'}}
				clearable={false}
				options={options}
			/>)
	}
}




// WEBPACK FOOTER //
// ./src/components/Form/ActiveSelect.js